import { useNavigate } from "react-router-dom";
import DetailRow from "../DetailRow";
import HeadingDialog from "../HeadingDialog";
import { timeStampToDateAndTime } from "../../../../functions/dateTime/timeStampToDateAndTime";
import { getExpenseStatus } from "../../../../functions/getExpenseStatus";
import { checkValue } from "../../../../functions/checkValue";
import Modal from "../../../portal/Modal";
import TabsView from "./TabsView";
import GradientButton from "../../buttonUI/GradientButton";
import GrayButton from "../../buttonUI/GrayButton";
import Remarks from "../../../remark/Remarks";
import { EXPENSE_REMARK } from "../../../../api/allApi_List";
import PictureList from "../PictureList";
import { formatDate } from "../../../../functions/dateTime/formatDate";
import successIcon from "../../../../assets/icons/successIcon.svg";

export default function ExpenseViewDialog({
  closeDialog,
  viewDetails,
  successMsg,
  openImageSlider,
  setImageSliderCurrentIndex,
  accept,
  reject,
  setExpenseViewDetails,
  currentListTab,
}) {
  const navigate = useNavigate();
  const backDate = viewDetails.backDated ? (
    <span className="expense-view-bd">BD</span>
  ) : (
    ""
  );
  return (
    <Modal
      onClose={successMsg ? undefined : closeDialog}
      closeIcon={!successMsg}
      modalWidth="view-dialog-content"
    >
      {!successMsg && <HeadingDialog heading="Expense Details" />}
      {successMsg && (
        <>
          <img
            src={successIcon}
            alt="messageIcon"
            className="mx-auto mb-1 w-9"
          />

          <p className="view-success-msg-d">{successMsg}</p>
        </>
      )}
      <div className={`max-h-[70vh] px-2 overflow-auto`}>
        <div className="view-dialog-content-wrap">
          <DetailRow title="User" value={viewDetails.user.fullName} />
          <DetailRow title="Amount" value={`₹${viewDetails.amount}`} />
          <div className={`${getExpenseStatus(viewDetails.state).textColor}`}>
            <DetailRow
              title="Status"
              value={getExpenseStatus(viewDetails.state).status}
            />
          </div>
          <DetailRow
            title="Description"
            value={checkValue(viewDetails.description)}
            textJustify="text-justify"
            widthDesc="w-64"
          />
          {viewDetails.receiver && (
            <DetailRow
              title="Received By"
              value={viewDetails.receiver.fullName}
            />
          )}
          <DetailRow title="Date" value={formatDate(viewDetails.date)}>
            {backDate}
          </DetailRow>
          <DetailRow
            title="Created By"
            value={viewDetails.createdBy.fullName}
          />
          <DetailRow
            title="Created At"
            value={timeStampToDateAndTime(viewDetails.createdAt)}
          />
          <DetailRow
            title="Last Updated By"
            value={viewDetails.updatedBy.fullName}
          />
          <DetailRow
            title="Last Updated At"
            value={timeStampToDateAndTime(viewDetails.updatedAt)}
          />
          <DetailRow
            title="Supervisor"
            value={viewDetails.supervisor.fullName}
          />
          <DetailRow title="Admin" value={viewDetails.admin.fullName} />
          <DetailRow
            title="Super Admin"
            value={viewDetails.superAdmin.fullName}
          />
        </div>
        {viewDetails.pictureList && (
          <PictureList
            pictureList={viewDetails.pictureList}
            openImageSlider={openImageSlider}
            setImageSliderCurrentIndex={setImageSliderCurrentIndex}
          />
        )}
        {!successMsg && (
          <Remarks
            remarkList={viewDetails.remarks}
            dataId={viewDetails.id}
            apiUrl={EXPENSE_REMARK}
            setViewDetails={setExpenseViewDetails}
            currenExpenseTab={currentListTab}
          />
        )}
        <TabsView expenseViewDetails={viewDetails} />
      </div>
      {accept && reject && (
        <div className="flex-center-align gap-2 mt-3">
          <GradientButton btnText="Accept" onClick={accept} />
          <GrayButton btnText="Reject" width="w-full" onClick={reject} />
        </div>
      )}
      {successMsg && (
        <div className="pt-5 text-center">
          <GradientButton
            btnText="Ok"
            width="w-28"
            onClick={() => navigate("/expense/all")}
          />
        </div>
      )}
    </Modal>
  );
}
